import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { getParameters } from '../../../helpers/urlHelpers';
import SelectionModal from '../components/SelectionModal';
import Trigger from '../components/Trigger';


Modal.setAppElement('body');
class OpcoNavigator extends Component {
  constructor(props) {
    super(props);

    const { autoOpenParam: { key: autoOpenKey, value: autoOpenValue } } = props;
    const queryParams = getParameters(location.href);


    this.state = {
      modalIsOpen: (queryParams[autoOpenKey] && (queryParams[autoOpenKey][0] === autoOpenValue)) || false,
      formValues: {
        location: {},
        locationType: '',
        ...props.currentSiteConfig,
      },
    };

    this.submitForm = this.submitForm.bind(this);
    this.updateFormValues = this.updateFormValues.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  updateFormValues(newValue) {
    const { formValues } = this.state;

    this.setState({
      formValues: {
        ...formValues,
        locationType: '',
        ...newValue,
      },
    });
  }

  submitForm() {
    const { redirectTo } = this.props;
    const {
      formValues: {
        location: { siteId, questionOptions },
        locationType,
      },
    } = this.state;

    if (typeof siteId === 'string') {
      window.location.assign(`${redirectTo}${siteId}`);

      return;
    }

    let idx = 0;

    if (locationType) {
      idx = questionOptions.indexOf(locationType);
    }

    window.location.assign(`${redirectTo}${siteId[idx]}`);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
    document.body.classList.add('no-scroll');
  }

  closeModal() {
    document.body.style.position = '';
    document.body.classList.remove('no-scroll');
    this.setState({ modalIsOpen: false });
  }

  render() {
    const {
      templateId,
      showDisclaimer,
      programConfig: { programName, programOptions, sectionOptions },
      currentSiteConfig,
      content,
    } = this.props;

    if (!programName) {
      return '';
    }

    const { formValues, modalIsOpen } = this.state;
    const { location } = currentSiteConfig;

    return (
      <div className="opco-navigator__container">
        <Trigger
          templateId={templateId}
          programName={programName}
          location={location}
          content={content}
          action={this.openModal}
        />
        <SelectionModal
          formValues={formValues}
          sectionOptions={sectionOptions}
          programOptions={programOptions}
          content={content}
          updateFormValues={this.updateFormValues}
          submitForm={this.submitForm}
          modalIsOpen={modalIsOpen}
          closeModal={this.closeModal}
          showDisclaimer={showDisclaimer}
        />
      </div>
    );
  }
}

OpcoNavigator.propTypes = {
  templateId: PropTypes.string.isRequired,
  redirectTo: PropTypes.string.isRequired,
  showDisclaimer: PropTypes.bool,
  content: PropTypes.shape({}).isRequired,
  programConfig: PropTypes.shape({
    programName: PropTypes.string,
    programOptions: PropTypes.arrayOf(PropTypes.shape({})),
    sectionOptions: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  currentSiteConfig: PropTypes.shape({
    location: PropTypes.shape({
      region: PropTypes.string,
      siteId: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.string,
      ]),
      questionOptions: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
  autoOpenParam: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
};

OpcoNavigator.defaultProps = {
  showDisclaimer: false,
};

export default OpcoNavigator;
